import { createFeature, createReducer, on } from '@ngrx/store';
import { LoginActions } from './login.actions';
import { LoadingState, StatusState } from '~shared/models/status-state';
import { LoginReasonsType } from '~login/services/login.service';

export const loginFeatureKey = 'login';

export interface LoginState {
    status: StatusState;
    error: LoginReasonsType | string | null;
    token: string | null;
}

export const initialState: LoginState = {
    status: LoadingState.default,
    error: null,
    token: null,
};

export const loginReducer = createReducer(
    initialState,
    on(LoginActions.login, (state) => ({
        ...state,
        status: LoadingState.loading,
        error: null,
        token: null,
    })),
    on(LoginActions.loginSuccess, (state, { token }) => ({
        ...state,
        status: LoadingState.default,
        error: null,
        token,
    })),
    on(LoginActions.loginFailure, (state, error) => ({
        ...state,
        status: LoadingState.default,
        error: error.error,
        token: null,
    })),
    on(LoginActions.logout, (state) => ({
        ...state,
        status: LoadingState.default,
        error: null,
        token: null,
    }))
);

export const loginFeature = createFeature({
    name: loginFeatureKey,
    reducer: loginReducer,
});
